import { Component, Input } from '@angular/core';
import { PaymentCardConfiguration } from '../../../../shared/interfaces';

@Component({
  selector: 'payment-card-bill-number',
  templateUrl: './payment-card-bill-number.component.html',
  styleUrls: ['./payment-card-bill-number.component.scss'],
})
export class PaymentCardBillNumberComponent {
  @Input() billNumber: string;
  @Input() billPeriod: string;
  @Input() config: PaymentCardConfiguration;
}
